import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import Icon from '../Icon';
import LabelDescriptionIcon from '../LabelDescriptionIcon';
import OutputNumberUnit from '../OutputNumberUnit';
import ProcurementOverviewLayout from '../ProcurementOverviewLayout';

class ProcurementOverview extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const { supplyNeedsBottles, supplyNeedsApples } = game.procurement;

		const variables = [
			{
				id: 'supply-needs-bottles',
				value: supplyNeedsBottles,
				icon: 'glassBottle',
				unit: 'u'
			},
			{
				id: 'supply-needs-apples',
				value: supplyNeedsApples,
				icon: 'apple',
				unit: 'kg'
			}
		];
		return (
			<div className="procurement-overview">
				<ProcurementOverviewLayout>
					<BusinessPlanSubSectionTitle
						label={'procurement-overview-bom-title'}
					/>
					<Icon icon={'bomOverview'} />
					<BusinessPlanSubSectionTitle
						label={'procurement-overview-dm-title'}
					/>
					<ThreeYearsTableLayout>
						<Header />
						{variables.map(variable => (
							<Row key={variable.id}>
								<Label>
									<LabelDescriptionIcon
										icon={variable.icon}
										label={variable.id}
									/>
								</Label>
								{range(1, 4).map(n => (
									<Col key={n}>
										<OutputNumberUnit
											active={!viewMode}
											variable={variable.value[n - 1]}
											unit={variable.unit}
										/>
									</Col>
								))}
							</Row>
						))}
					</ThreeYearsTableLayout>
				</ProcurementOverviewLayout>
			</div>
		);
	}
}

ProcurementOverview.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		procurement: PropTypes.shape({
			supplyNeedsBottles: MultiYearScalarType,
			supplyNeedsApples: MultiYearScalarType
		})
	})
};

export default ProcurementOverview;
